import { render, staticRenderFns } from "./ProductOffer.vue?vue&type=template&id=621c6126&scoped=true&"
import script from "./ProductOffer.vue?vue&type=script&lang=js&"
export * from "./ProductOffer.vue?vue&type=script&lang=js&"
import style0 from "./ProductOffer.vue?vue&type=style&index=0&id=621c6126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c6126",
  null
  
)

export default component.exports